export const quizQuestions = {
  DescribeYourSelfPage: [
    {
      value: 'creator_or_influencer',
      icon: '🎥',
      label: 'funnel.questions.creator_or_influencer',
    },
    {
      value: 'business_owner',
      icon: '💼',
      label: 'funnel.questions.business_owner',
    },
    {
      value: 'marketing_professional',
      icon: '📈',
      label: 'funnel.questions.marketing_professional',
    },
    {
      value: 'unemployed',
      icon: '🔍',
      label: 'funnel.questions.unemployed',
    },
  ],
  ContentAboutPage: [
    {
      value: 'lifestyle_&_daily_life',
      icon: '🏡',
      label: 'funnel.questions.lifestyle_&_daily_life',
    },
    {
      value: 'health_&_fitness',
      icon: '🏋️‍♂️',
      label: 'funnel.questions.health_&_fitness',
    },
    {
      value: 'beauty_&_skincare',
      icon: '💄',
      label: 'funnel.questions.beauty_&_skincare',
    },
    {
      value: 'fashion_&_style',
      icon: '👗',
      label: 'funnel.questions.fashion_&_style',
    },
    {
      value: 'personal_growth_&_mindset',
      icon: '🌱',
      label: 'funnel.questions.personal_growth_&_mindset',
    },
    {
      value: 'business_&_entrepreneurship',
      icon: '💼',
      label: 'funnel.questions.business_&_entrepreneurship',
    },
    {
      value: 'marketing_&_social_media_tips',
      icon: '📣',
      label: 'funnel.questions.marketing_&_social_media_tips',
    },
    {
      value: 'education_&_how_to',
      icon: '📘',
      label: 'funnel.questions.education_&_how_to',
    },
    {
      value: 'tech_&_productivity',
      icon: '💻',
      label: 'funnel.questions.tech_&_productivity',
    },
    {
      value: 'art_&_design_&_creativity',
      icon: '🎨',
      label: 'funnel.questions.art_&_design_&_creativity',
    },
    {
      value: 'food_&_cooking_&_recipes',
      icon: '🍽️',
      label: 'funnel.questions.food_&_cooking_&_recipes',
    },
    {
      value: 'travel_&_experiences',
      icon: '✈️',
      label: 'funnel.questions.travel_&_experiences',
    },
    {
      value: 'i_m_not_sure_yet',
      label: 'funnel.questions.i_m_not_sure_yet',
    },
  ],
  WhatPlatformPage: [
    {
      value: 'tiktok',
      icon: 'tiktok',
      iconType: 'svg',
      label: 'funnel.questions.tiktok',
    },
    {
      value: 'instagram',
      icon: 'instagram',
      iconType: 'svg',
      label: 'funnel.questions.instagram',
    },
    {
      value: 'youtube',
      icon: 'youtube',
      iconType: 'svg',
      label: 'funnel.questions.youtube',
    },
    {
      value: 'getting_started',
      label: 'funnel.questions.getting_started',
    },
  ],
  FollowersCountPage: [
    {
      value: '0–100',
      label: '0–100',
    },
    {
      value: '100–500',
      label: '100–500',
    },
    {
      value: '500–1,000',
      label: '500–1,000',
    },
    {
      value: '1,000–3,000',
      label: '1,000–3,000',
    },
    {
      value: '3,000–10,000',
      label: '3,000–10,000',
    },
    {
      value: '10,000+',
      label: 'funnel.questions.10000+',
    },
  ],
  FollowersGoalPage: [
    {
      value: '1,000',
      label: 'funnel.questions.1000',
    },
    {
      value: '1,000–3,000',
      label: '1,000–3,000',
    },
    {
      value: '3,000–5,000',
      label: '3,000–5,000',
    },
    {
      value: '5,000–10,000',
      label: '5,000–10,000',
    },
    {
      value: '10,000+',
      label: '10,000+',
    },
  ],
  UserLevelPage: [
    {
      value: 'just_getting_started',
      icon: 'level0',
      iconType: 'svg',
      label: 'funnel.questions.just_getting_started',
      details: 'funnel.everyone_starts',
    },
    {
      value: 'posting_occasionally',
      icon: 'level1',
      iconType: 'svg',
      label: 'funnel.questions.posting_occasionally',
      details: 'funnel.find_your_direction',
    },
    {
      value: 'posting_regularly_but_not_growing',
      icon: 'level2',
      iconType: 'svg',
      label: 'funnel.questions.posting_regularly_but_not_growing',
      details: 'funnel.zero_in_on_growth',
    },
    {
      value: 'growing_and_ready_to_scale',
      icon: 'level3',
      iconType: 'svg',
      label: 'funnel.questions.growing_and_ready_to_scale',
      details: 'funnel.focus_on_growth',
    },
  ],
  WantToAchievePage: [
    {
      value: 'grow_my_account',
      label: 'funnel.questions.grow_my_account',
      icon: '📈',
    },
    {
      value: 'get_more_views',
      label: 'funnel.questions.get_more_views',
      icon: '🎯',
    },
    {
      value: 'build_trust',
      label: 'funnel.questions.build_trust',
      icon: '🤝',
    },
    {
      value: 'make_my_content_professional',
      label: 'funnel.questions.make_my_content_professional',
      icon: '🎨',
    },
    {
      value: 'set_up_content_for_monetization',
      label: 'funnel.questions.set_up_content_for_monetization',
      icon: '💰',
    },
    {
      value: 'post_consistently',
      label: 'funnel.questions.post_consistently',
      icon: '🔄',
    },
  ],
  HoldingBackPage: [
    {
      value: 'dont_know_what_to_post',
      label: 'funnel.questions.dont_know_what_to_post',
    },
    {
      value: 'afraid_to_look_cringe',
      label: 'funnel.questions.afraid_to_look_cringe',
    },
    {
      value: 'overthink_every_idea',
      label: 'funnel.questions.overthink_every_idea',
    },
    {
      value: 'lose_motivation_fast',
      label: 'funnel.questions.lose_motivation_fast',
    },
    {
      value: 'dont_have_clear_plan',
      label: 'funnel.questions.dont_have_clear_plan',
    },
    {
      value: 'get_overwhelmed_and_freeze',
      label: 'funnel.questions.get_overwhelmed_and_freeze',
    },
  ],
  agreement: [
    {
      value: 'strongly_disagree',
      label: 'funnel.questions.strongly_disagree',
      icon: '❌',
    },
    {
      value: 'somewhat_disagree',
      label: 'funnel.questions.somewhat_disagree',
      icon: '👎',
    },
    {
      value: 'somewhat_agree',
      label: 'funnel.questions.somewhat_agree',
      icon: '👍',
    },
    {
      value: 'strongly_agree',
      label: 'funnel.questions.strongly_agree',
      icon: '✅',
    },
  ],
  ContentCreationEasierPage: [
    {
      value: 'ai_ideas',
      label: 'funnel.questions.ai_ideas',
    },
    {
      value: 'fast_scripts',
      label: 'funnel.questions.fast_scripts',
    },
    {
      value: 'strong_hooks',
      label: 'funnel.questions.strong_hooks',
    },
    {
      value: 'daily_structure',
      label: 'funnel.questions.daily_structure',
    },
  ],
  SpentTimeOnContentPage: [
    {
      value: '10-15 minutes',
      label: ['10-15', 'common.minutes_other'],
    },
    {
      value: '20-30 minutes',
      label: ['20-30', 'common.minutes_other'],
    },
    {
      value: '40-60 minutes',
      label: ['40-60', 'common.minutes_other'],
    },
    {
      value: '1-2 hours',
      label: ['1-2', 'common.hours_other'],
    },
  ],
  PlanTargetsPage: [
    {
      value: 'clear_direction',
      label: 'funnel.questions.clear_direction',
    },
    {
      value: 'ideas_immediately',
      label: 'funnel.questions.ideas_immediately',
    },
    {
      value: 'simple_structure',
      label: 'funnel.questions.simple_structure',
    },
    {
      value: 'less_guessing',
      label: 'funnel.questions.less_guessing',
    },
    {
      value: 'consistent_progress',
      label: 'funnel.questions.consistent_progress',
    },
    {
      value: 'what_actually_works',
      label: 'funnel.questions.what_actually_works',
    },
  ],
  AvoidWhatPage: [
    {
      value: 'wasting_time',
      label: 'funnel.questions.wasting_time',
    },
    {
      value: 'posting_randomly',
      label: 'funnel.questions.posting_randomly',
    },
    {
      value: 'out_of_ideas',
      label: 'funnel.questions.out_of_ideas',
    },
    {
      value: 'overthinking_content',
      label: 'funnel.questions.overthinking_content',
    },
    {
      value: 'losing_motivation',
      label: 'funnel.questions.losing_motivation',
    },
    {
      value: 'overwhelmed_burned_out',
      label: 'funnel.questions.overwhelmed_burned_out',
    },
  ],
  KnowHowMonetizePage: [
    {
      value: 'yes',
      icon: '✅',
      label: 'common.yes',
    },
    {
      value: 'no',
      icon: '❌',
      label: 'common.no',
    },
  ],
  StartMonetizingPage: [
    {
      value: 'earning',
      icon: '💰',
      label: 'funnel.questions.earning',
    },
    {
      value: 'small',
      icon: '💸',
      label: 'funnel.questions.small',
    },
    {
      value: 'no_results',
      icon: '😕',
      label: 'funnel.questions.no_results',
    },
    {
      value: 'not_yet',
      icon: '⏳',
      label: 'funnel.questions.not_yet',
    },
  ],
  IncomeGoalPage: [
    {
      value: '$1,000',
      icon: '💵',
      label: '$1,000',
    },
    {
      value: '$1,000 – $5,000',
      icon: '💸',
      label: '$1,000 – $5,000',
    },
    {
      value: '$5,000 – $10,000',
      icon: '💰',
      label: '$5,000 – $10,000',
    },
    {
      value: '$10,000 – $15,000',
      icon: '💎',
      label: '$10,000 – $15,000',
    },
    {
      value: '$15,000+',
      icon: '🚀',
      label: '$15,000+',
    },
  ],
};

// console.log(
//   (() => {
//     const result = {};
//     for (const list in quizQuestions) {
//       quizQuestions[list].forEach((item) => {
//         result[item.value] = item.label;
//       });
//     }
//     return JSON.stringify(result);
//   })()
// );
